import { makeReadableName } from "@/shared/utils/common.utils";
import {
  AssessmentRoleEnum,
  AssessmentRolesDescription,
} from "@/modules/assessments/services/assessment-permissions-http.service";
import { IAssessmentRole } from "@/shared/services/roles/roles-http.service";

export interface IAssessmentRoleOption {
  value: AssessmentRoleEnum;
  name: string;
  description?: string;
}

export function getAssessmentRoleOptions(assessmentRoles: IAssessmentRole[]): IAssessmentRoleOption[] {
  if (!assessmentRoles || assessmentRoles.length === 0) {
    return [];
  }

  // Admin role is not surfaced to users and is only set automatically by the API for client admins when they create an assessment.
  const filteredAssessmentRoles = assessmentRoles.filter((role) => role.name !== AssessmentRoleEnum.ADMIN);

  return filteredAssessmentRoles.map((role) => ({
    value: role.name,
    description: AssessmentRolesDescription[role.name as keyof typeof AssessmentRolesDescription],
    name: makeReadableName(role.name),
  }));
}
